import React from "react";

// Opens external destinations (Instagram, YouTube, LinkedIn, podcasts, partners)
// in a new top-level browser tab — reliably, even when the app is embedded in an
// iframe. Never navigates the user away from the main site.
export const ExternalLink = ({ href, children, className = "", ...props }) => {
  const openExternal = (e) => {
    e.preventDefault();
    const win = window.open(href, "_blank", "noopener,noreferrer");
    if (win) win.opener = null;
  };
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      onClick={openExternal}
      className={className}
      {...props}
    >
      {children}
    </a>
  );
};

export default ExternalLink;
